import svg4everybody from 'svg4everybody'; // polyfil for External Svg IE 9 - 10 - 11

document.addEventListener('DOMContentLoaded', () => {
   svg4everybody(); 
});





// WEBPACK FOOTER //
// ./assets/src/js/modules/svg4everybody.js